import { EChartsOption } from 'echarts';
const WeatherOptionLine: EChartsOption = {
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'cross',
            crossStyle: {
                color: '#999',
            },
        },
    },
    toolbox: {
        feature: {
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar'], title: { line: '切换为曲线图' } },
            restore: { show: true },
            saveAsImage: { show: true },
        },
    },

    grid: {
        left: 100,
        right: 100,
        backgroundColor: 'transparent',
    },
    yAxis: {},
    series: [{}],
};
export default WeatherOptionLine;
